import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { getBookApi, updateBookApi } from '../../utils/api';

const GENRES = ['Fiction','Non-Fiction','Mystery','Romance','Sci-Fi','Fantasy','Biography','Self-Help','Horror','Thriller','History','Other'];
const S = process.env.REACT_APP_API_URL?.replace('/api','') || '';

export default function AdminEditBook() {
  const { id } = useParams(); const navigate = useNavigate();
  const [form, setForm] = useState({ title:'', description:'', genre:'Fiction', price:'', author:'', tags:'', published:'true' });
  const [file, setFile] = useState(null); const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false); const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBookApi(id).then(({data}) => {
      setForm({ title:data.title||'', description:data.description||'', genre:data.genre||'Fiction', price:data.price||'', author:data.author||'', tags:(data.tags||[]).join(', '), published:data.published?'true':'false' });
      if (data.coverImage) setPreview(data.coverImage.startsWith('http') ? data.coverImage : `${S}${data.coverImage}`);
    }).finally(()=>setLoading(false));
  }, [id]);

  const submit = async (e) => {
    e.preventDefault(); setError(''); setBusy(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v])=>fd.append(k,v));
      if (file) fd.append('coverImage', file);
      await updateBookApi(id, fd); navigate('/admin/books');
    } catch(err) { setError(err.response?.data?.message||'Failed'); }
    finally { setBusy(false); }
  };

  if (loading) return <AdminLayout title="Edit Book"><div className="spinner"/></AdminLayout>;

  return (
    <AdminLayout title={`Edit — ${form.title}`}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', padding:'32px', maxWidth:900 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:28 }}>
          <h2 style={{ fontFamily:'var(--font-d)', fontSize:'1.2rem', color:'var(--text2)' }}>Book Details</h2>
          <Link to={`/admin/books/${id}/chapters`} className="btn btn-ghost btn-sm">Manage Chapters →</Link>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          <div style={{ display:'grid', gridTemplateColumns:'200px 1fr', gap:40 }}>
            <div>
              <label style={{ display:'block', cursor:'pointer', border:'2px dashed var(--border2)', borderRadius:12, overflow:'hidden' }}>
                {preview ? <img src={preview} alt="" style={{width:'100%',display:'block',aspectRatio:'2/3',objectFit:'cover'}}/>
                  : <div style={{aspectRatio:'2/3',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:8,background:'var(--bg3)'}}>
                      <span style={{fontSize:'2rem'}}>🖼️</span><span style={{color:'var(--text3)',fontSize:'0.78rem'}}>Upload new cover</span>
                    </div>}
                <input type="file" accept="image/*" style={{display:'none'}} onChange={e=>{const f=e.target.files[0];if(f){setFile(f);setPreview(URL.createObjectURL(f));}}} />
              </label>
            </div>
            <div>
              <div className="form-group"><label>Title *</label><input className="form-control" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} required/></div>
              <div className="form-group"><label>Author</label><input className="form-control" value={form.author} onChange={e=>setForm({...form,author:e.target.value})}/></div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:16}}>
                <div className="form-group"><label>Genre</label>
                  <select className="form-control" value={form.genre} onChange={e=>setForm({...form,genre:e.target.value})}>
                    {GENRES.map(g=><option key={g}>{g}</option>)}
                  </select>
                </div>
                <div className="form-group"><label>Price ₹</label><input className="form-control" type="number" min="0" value={form.price} onChange={e=>setForm({...form,price:e.target.value})}/></div>
                <div className="form-group"><label>Status</label>
                  <select className="form-control" value={form.published} onChange={e=>setForm({...form,published:e.target.value})}>
                    <option value="true">Published</option><option value="false">Draft</option>
                  </select>
                </div>
              </div>
              <div className="form-group"><label>Description *</label><textarea className="form-control" rows={4} value={form.description} onChange={e=>setForm({...form,description:e.target.value})} required/></div>
              <div className="form-group"><label>Tags</label><input className="form-control" value={form.tags} onChange={e=>setForm({...form,tags:e.target.value})}/></div>
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end',gap:12,paddingTop:24,borderTop:'1px solid var(--border)',marginTop:16}}>
            <button type="button" className="btn btn-ghost" onClick={()=>navigate('/admin/books')}>Cancel</button>
            <button type="submit" className="btn btn-gold" disabled={busy}>{busy?'Saving…':'Save Changes'}</button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
}
